<script>
import BoxComponent from '@/components/BoxComponent.vue'
import Papa from 'papaparse'
// import productsCSV from '../products.csv'

export default {
  props: {
    value: String,
  },
  components: {
    BoxComponent,
  },
  data() {
    return {
      localValue: '',
      productsCSV: [],
      boxArr: [], //array of boxes
    }
  },
  methods: {
    //test barcode
    //30058633
    //97609353


    createBox() {
      this.boxArr.push({ barcode: [], name: [] })
      console.log('hey')
    },
    handleFileUpload(event){
      const file = event.target.files[0]
      if (file) {
        Papa.parse(file, {
          header: true, // Treat the first row as headers
          skipEmptyLines: true, // Skip any empty lines in the file
          complete: (results) => {
            // The parsed data is available in results.data as an array of objects
            this.productsCSV = results.data;
            console.log("Parsing complete:", this.productsCSV);
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
          }
        })
      }

      // var product = productsCSV.filter(
      //     (el) => el['Variant Barcode'] === this.localValue.toString(),
      //   )[0]
        // var product = file.filter(
        //   (el) => el['Variant Barcode'] === '30058633',
        // )[0]
        // console.log(product)

    }
  },
  created() {

  },
}
</script>

<template>
  <h1>Scan Boxzooka Boxes</h1>
  <p>Program to help organize boxes sent to Boxzooka. <br>Upload products file and scan every item that goes into a box. <br> Create a new box and repeat.</p>
  <p v-if="!productsCSV.length">Products</p> <input v-if="!productsCSV.length" id="choose-file" type="file" @change="handleFileUpload" accept=".csv" />
  <div class="container">
    <div class="box" v-for="(box, boxIndex) in this.boxArr" :key="boxIndex">
      <BoxComponent :boxContents="boxArr[boxIndex]" :boxNum="boxIndex" :products="this.productsCSV"/>
    </div>
  </div>
  <button @click="createBox">Add New Box</button>
</template>

<style lang="scss" scoped>
.main {
  input {
    text-align: center;
    margin: auto;
    width: 50%;
  }
}
.container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
}
</style>
